import React from 'react'
import Hero from '../components/hero/Hero'
import About from '../components/about/About'
import Services from '../components/services/Services'
import Testimonials from '../components/testimonials/Testimonials'
import Plans from '../components/plans/Plans'
import Presence from '../components/presence/Presence'
import SoftwareBlog from '../components/blog/SoftwareBlog'


function Software() {

  return (
    <>
      <Hero />
      <About />
      <Services />
      <Testimonials />
      <Plans />
      <Presence />
      <SoftwareBlog />
    </>
  )
}

export default Software
